import { Controller } from "stimulus"
import moment from "moment"
const axios = require('axios')

export default class extends Controller {

  static targets=["workingArea","searchText", "searchResults",
                  "added", "additionalMembers", "totalCost", "addMemberBox", "additionalMembersBox",
                  "tableDiv","childTable", "newMemberForm", "addTitle", "addFirstname", "addLastname", "addEmail",
                   "errorBox", "mainSubPrice", "mainAddPrice", "modal", "addCost", "additionalTableBody", "endDate",
                  "realTotal", "cost", "donation", "addButton","addMember", "addMemberErrors", "hasAdditional", "removeRowButton"]

    connect(){
      let that = this
      this.searching = false
      this.making = false
      this.maxAddMembers = 0
      axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      axios.defaults.headers.post['Content-Type'] = 'application/json';
      axios.defaults.headers['Accept'] = 'application/json';
      this.current_costs = JSON.parse(this.data.get("current-costs"))
      this.addedCount = parseInt(this.data.get("addedCount"))

      setTimeout(function(){that.recalcTotal()}, 1000)//when just connected data not yet in page wait a little while, turbolinks:load@window not firing on first visit
      if(this.data.get("has-additional") == 'true')
      {
        setTimeout(function(){

          let ev = new Event('click')
          that.addMemberTarget.dispatchEvent(ev)
        }, 1000)
      }
      //this.checkAdded()
    }

   addYear(e){
     let old = moment(e.target.value, "DD-MMM-YYYY")
     let newDate = old.add(1,'years')
     let fp = this.endDateTarget._flatpickr
      if(fp){
          fp.setDate(newDate.toDate())
      }
   }

   searchForm(e) {
      if(this.searching)
      {
        this.closeSearch()
      }
      else
      {
        if(this.making)
        {
          this.closeAddPerson()
        }
        this.searching = true
        this.making = false
        let formString = `
        <div id="search-form" >
        <h5>Search for Member to add</h5>
        <input type='text' class='w-100' data-target='subscriptions.searchText' placeholder='name like, please start typing' data-action='keyup->subscriptions#search'/>
        <div data-target='subscriptions.searchResults'></div>
        </div>
        `
       this.workingAreaTarget.innerHTML =  formString
      }

    }

    search(e){
      let that = this
     if (e.target.value.length < 2 )
     {
       this.searchResultsTarget.innerHTML=""
       return
     }
     else
     {
       axios.get('/admin/members/autocomplete',{
         params:{
           term: e.target.value
         }
       }).then(
         function(response){
           let result = []
           Array.from(response.data).map(function(x){
             result.push(x.id)
           })
           that.addedTarget.value = result.join(",")
           let html = that.createList(response.data)
           that.searchResultsTarget.innerHTML=html
         }
       )
     }
    }

    createList(data){
      let that=this
      let  memberids = this.addedTarget.value.split(",")
          let out=["<ul>"]
      Array.from(data).forEach(function(member, idx){
        if (member.id == that.data.get("member-id"))
        {

        }
        else
        {
          out.push(`<li class="btn btn-secondary w-100" data-id="${member.id}" data-action="click->subscriptions#selectMember">${member.firstname} ${member.lastname} membership: ${member.membership_no}</li>`)
        }

      })


      out.push("</ul>")
      return out.join("")
    }

    closeAddPerson(){
      if(!this.making)
      {return}
      this.making = false
      this.addMemberBoxTarget.classList.add("d-none")
      Array.from(this.addMemberBoxTarget.querySelectorAll("input")).forEach(function(ip){
        ip.value=""
      })
      if(this.addedCount > 0)
      {this.addedCount -= 1}
      this.hasAdditionalTarget.value = 'false'
      this.recalcTotal()
    }

    newMember(){
      if(this.making)
      {
        this.closeAddPerson()

      }
      else
      {
        this.making = true
        this.addMemberBoxTarget.classList.remove("d-none")
        this.workingAreaTarget.innerHTML = ""
        this.searching = false
        this.hasAdditionalTarget.value = 'true'
        this.checkAdded()
      }
      this.recalcTotal()
    }



    closeSearch(){
      this.searching = false
      this.workingAreaTarget.innerHTML = ""
    }



    selectMember(e){
      let that=this
      let id = e.target.dataset.id
      let path = "/admin/members/" + this.data.get("memberId") + "/subscriptions/add_member"
      axios.get(path, {
        params: {
          add_member_id: id
        }
      }).then(function(response){
          that.additionalMembersTarget.insertAdjacentHTML('beforeend', response.data.html)
          that.childTableTarget.insertAdjacentHTML('beforeend', response.data.row)
          that.searchResultsTarget.innerHTML=""
          that.searchTextTarget.value=""
          that.closeSearch()
          that.addedCount += 1
          that.recalcTotal()
          that.checkAdded()
        })
    }

    removeMember(e){
      let member_id = e.target.dataset.member
      let row = document.getElementById("child-row-" + member_id)
      let  member_ids = this.addedTarget.value.split(",")

      this.addedTarget.value = member_ids.splice(member_ids.indexOf(member_id), 2)
      let hidden = document.getElementById("hidden-child-" + member_id)
      hidden.remove()
      row.remove()
      if(this.addedCount > 0)
      {
          this.addedCount -= 1
      }
      this.recalcTotal()
      this.checkAdded()
    }

    addMember(){

      let that = this
      let member = {
        title: this.addTitleTarget.value,
        firstname: this.addFirstnameTarget.value,
        lastname: this.addLastnameTarget.value,
        email: this.addEmailTarget.value
      }
      axios.get("/subscriptions/validate_additional", {
        params:{
          member: member
        }
      }).then(function(result){
        if(result.data.result === true)
        {

          let token = Date.now().toString()
          let new_row = that.additionalMemberRow(member, token )
          that.additionalTableBodyTarget.insertAdjacentHTML("beforeend", new_row)
          let fields = that.additionalMemberFields(member,token)
          that.additionalMembersBoxTarget.insertAdjacentHTML("beforeend", fields)
          that.clearAdditionalFields()
          that.addMemberErrorsTarget.classList.add("d-none")
          that.addMemberErrorsTarget.innerHTML=""
          that.addedCount += 1
          that.checkAdded()
          that.recalcTotal()
        }
        else
        {
          that.addMemberErrorsTarget.innerHTML = result.data.messages
          that.addMemberErrorsTarget.classList.remove("d-none")
          if(result.data.errors.title)
          {
            that.addTitleTarget.classList.add("is-invalid")
          }
          else
          {
            that.addTitleTarget.classList.remove("is-invalid")
          }
          if(result.data.errors.firstname)
          {
            that.addFirstnameTarget.classList.add("is-invalid")
          }
          else
          {
            that.addFirstnameTarget.classList.remove("is-invalid")
          }
          if(result.data.errors.lastname)
          {
            that.addLastnameTarget.classList.add("is-invalid")
          }
          else
          {
            that.addLastnameTarget.classList.remove("is-invalid")
          }
          if(result.data.errors.email)
          {
            that.addEmailTarget.classList.add("is-invalid")
          }
          else
          {
            that.addEmailTarget.classList.remove("is-invalid")
          }
        }
      })

    }

    clearAdditionalFields(){

      let inputs = Array.from(this.addMemberBoxTarget.querySelectorAll("input"))
      inputs.forEach(function(inp){
        inp.value=""
        inp.classList.remove("is-invalid")
      })
    }

    removeAdditional(e){
      e.preventDefault()
      let token = e.target.dataset.id
      let isExisting = e.target.dataset.existing
      let trow = this.additionalTableBodyTarget.querySelector(`tr[data-id='${token}']`)
      trow.remove()
      let div = this.additionalMembersBoxTarget.querySelector(`div[data-id='${token}']`)
      div.remove()
      this.addedCount -= 1
      this.recalcTotal()
      this.checkAdded()
    }

    removeAllAdditional(){
      let ev = new Event('click')
      this.closeAddPerson()
      this.removeRowButtonTargets.forEach(function(btn){
        btn.dispatchEvent(ev)
      })
    }

    recalcTotal(){
      let that=this
      let total = 0.0
      let main = parseFloat(this.mainSubPriceTarget.innerHTML)
      let added = parseFloat(this.mainAddPriceTarget.innerHTML)

      total = total + main
      total = total + (added * this.addedCount)
      this.addCostTargets.forEach(function(subcost){
        subcost.innerHTML = that.mainAddPriceTarget.innerHTML
      })
      this.totalCost = total
      this.totalCostTarget.innerHTML = total.toFixed(2)
      this.realTotalTarget.value = total.toFixed(2)
    }


  changeLevel(e){
    if(e.target.value === "")
    {
        this.mainSubPriceTarget.innerHTML="0.00"
        this.mainAddPriceTarget.innerHTML ="0.00"
        this.addedCount=0
        this.maxAddMembers = 0
    }
    else
    {
      console.log(this.current_costs)
      this.maxAddMembers = parseInt(this.current_costs[e.target.value][2]) - 1
      let cost = this.current_costs[e.target.value][0]
      let formatted = parseFloat(cost).toFixed(2).toString()
      this.mainSubPriceTarget.innerHTML=formatted
      let sub_cost = this.current_costs[e.target.value][1]
      if (sub_cost == "" || sub_cost == undefined)
      {sub_cost = 0}
      var subCostFormatted =  parseFloat(sub_cost).toFixed(2).toString()
      this.mainAddPriceTarget.innerHTML = subCostFormatted
      this.addCostTarget.innerHTML = subCostFormatted

    }
  
    if(e.target.value == "" || this.maxAddMembers == 0 || this.addedCount > this.maxAddMembers)
    {
      this.removeAllAdditional()
      this.disableButtons()
    }
    else
    {
      this.enableButtons()
    }
    this.recalcTotal()
  }

  disableButtons(){
    //this.removeAllAdditional()
    //this.closeAddPerson()
    this.addButtonTargets.forEach(function(b){
      b.disabled = true
    })

  }

  enableButtons(){
    this.addButtonTargets.forEach(function(b){
      b.disabled = false
    })
  }

  checkAdded(){
    if( this.addedCount > 0 && this.addedCount >= this.maxAddMembers)
    {
      this.disableButtons()
      this.addMemberBoxTarget.classList.add("d-none")
      this.making = false
    }
    else
    {
      this.enableButtons()
    }
  }

  additionalMemberRow(member,token){

   let out =  `
    <tr data-id=${token}>
    <td>${member.title}</td>
    <td>${member.firstname}</td>
    <td>${member.lastname}</td>
    <td>${member.email}</td>
    <td data-subscriptions-target="addCost"></td>
    <td>
      <button data-action="click->subscriptions#removeAdditional" data-id=${token} class="btn btn-sm btn-danger type="button" name="button">Remove</button>
    </td>
    </tr>
   `
   return out
  }

  additionalMemberFields(member,token){
    let out = `
    <div data-id=${token}>
    <input type="hidden" name="subscription[members][${token}][title]" value="${member.title}"/>
    <input type="hidden" name="subscription[members][${token}][firstname]" value="${member.firstname}"/>
    <input type="hidden" name="subscription[members][${token}][lastname]" value="${member.lastname}"/>
    <input type="hidden" name="subscription[members][${token}][email]" value="${member.email}"/>
    </div>
    `
    return out
  }

}
